class DiscountReasonCodeController extends AbstractEntityEditController
	@register()
	@inject 'discountReasonCode',
		'ReasonCodeRepository',
		'BACKEND_REASON_CODE_ENTITY_TYPE'

	initialize: ->
		@mainCrud.entityType = 'general.discount.reason.code'
		@mainCrud.entityTitle = 'general.discount.reason.code.new'

		if @discountReasonCode.id?
			@mainCrud.entityType = @discountReasonCode.code
			@mainCrud.entityTitle = @discountReasonCode.name
			@mainCrud.isNewEntity = false
		else
			@discountReasonCode.entity_type = @BACKEND_REASON_CODE_ENTITY_TYPE.DISCOUNT

	save: ->
		@ReasonCodeRepository
			.save(@discountReasonCode, @mainCrud.isNewEntity)
			.then (response) =>
				@afterSave(response)
			.catch (response) =>
				@handleErrors(response)

	delete: ->
		@deleteEntity(@ReasonCodeRepository, @discountReasonCode)
